import React from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

export default function Footer() {
  return (
    <div className="w-full bottom-0 left-0 text-center text-white">
      <div className="bg-[#0043D3] opacity-90 p-4">
        Copyright © 2025 Hexagon Corporation
      </div>
    </div>
  );
}
